var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpiAppIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 25,
    viewBox: "0 0 18 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.55092 20L0.176713 25L0 24.8649C0.613304 22.578 1.22661 20.3015 1.85031 18.0249C3.40956 12.3597 4.96881 6.7048 6.53845 1.03953C6.53845 1.01874 6.53845 0.997954 6.53845 0.987559C6.53845 0.706895 6.68398 0.44702 6.93346 0.311885C7.30768 0.249515 7.29728 0.67571 7.43242 0.914795C8.23283 2.39088 8.83574 3.96053 9.77129 5.36385C10.6549 7.50522 11.684 9.63619 12.7962 11.6632C12.9314 11.8711 13.0145 12.1102 13.0145 12.3597C13.0145 12.7859 12.7962 13.1913 12.4324 13.42C10.0935 15.5925 7.82742 17.8067 5.55092 20Z",
    fill: "#F07A25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.55066 20C7.83756 17.8066 10.1037 15.5925 12.4218 13.4303C12.7856 13.2016 13.0039 12.7962 13.0039 12.37C13.0039 12.1206 12.9311 11.8815 12.7856 11.6736C11.6629 9.64655 10.6442 7.51558 9.76064 5.37421L11.3615 0C12.0267 1.27858 12.5777 2.32848 13.1078 3.38877C14.4488 6.06028 15.7585 8.75258 17.1515 11.4033C17.3386 11.6632 17.4321 11.975 17.4321 12.2973C17.4321 12.8274 17.1619 13.3264 16.7045 13.607C12.8999 17.1309 9.16812 20.738 5.41553 24.3139C5.17645 24.6257 4.8542 24.8648 4.47998 24.9896C4.95815 23.3575 5.32197 21.6839 5.55066 20Z",
    fill: "#0C8D48"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpiAppIcon);
export default __webpack_public_path__ + "static/media/upiApp_icon.2f6643eb3c8ae7c766565e7735145f10.svg";
export { ForwardRef as ReactComponent };